<template>
  <div class="home-container overflowY background-box">
    <!-- <img src="@/assets/images/home/home-back.png" class="home-back-img"></img> -->
    <van-row class="banner">
      <img src="@/assets/images/home/home-banner-bck.png">
      <!-- <div class="title-box">
        <img src="@/assets/images/home-logo.png" class="logo" />
      </div> -->
    </van-row>
    <div class="banner-menu">
      <div class="menu-item">
        <div class="icon flexLayout" @click="menuLink('H101')">
          <img src="@/assets/images/home/repair-icon.png"></img>
        </div>
        <span>维修</span>
      </div>
      <div class="menu-item">
        <div class="icon flexLayout" @click="menuLink('H102')">
          <img src="@/assets/images/home/relocation-icon.png"></img>
        </div>
        <span>移机</span>
      </div>
      <div class="menu-item">
        <div class="icon flexLayout" @click="menuLink('H103')">
          <img src="@/assets/images/home/cleaning-icon.png"></img>
        </div>
        <span>清洗保养</span>
      </div>
      <div class="menu-item">
        <div class="icon flexLayout" @click="menuLink('H104')">
          <img src="@/assets/images/home/inquiry-icon.png"></img>
        </div>
        <span>进度查询</span>
      </div>
    </div>
    <div class="appointment-block">
      <div class="block-title">特色服务</div>
      <div class="cnt">
        <img src="@/assets/images/home/appointment-bck.png" class="logo" />
        <div class="tip-box">
          <div class="hi">Hi,我是您的视频工程师</div>
          <div class="ti" v-if="appointmentStatus == '1' || appointmentStatus == '2'">
            {{ appointmentStatus == '1' ? '您的预约服务已经开始' : '您的预约服务尚未开始'}}
            <span @click="miniAppVideo()" v-if="appointmentStatus == '1'" style="color: #3E8FD2;">发起视频通话</span>
          </div>
          <div class="ti" v-else>您暂无视频工程师预约</div>
        </div>
        <div class="btn" @click="menuLink('H105')">视频客服在线预约</div>
      </div>
    </div>
    <div class="appointment-block self-service-block">
      <div class="block-title">自助服务</div>
      <div class="cnt2">
        <div class="menu-item-2" @click="menuLink('H107')">
          <img src="@/assets/images/home/charge-icon.svg"></img>
          <span>收费标准</span>
        </div>
        <div class="menu-item-2" @click="menuLink('H108')">
          <img src="@/assets/images/home/warranty-icon.svg"></img>
          <span>保修政策</span>
        </div>
        <div class="menu-item-2" @click="menuLink('H109')">
          <img src="@/assets/images/home/service-icon.svg"></img>
          <span>服务标准</span>
        </div>
        <div class="menu-item-2" @click="menuLink('H110')">
          <img src="@/assets/images/home/fault-icon.svg"></img>
          <span>故障代码</span>
        </div>
        <div class="menu-item-2" @click="menuLink('H111')">
          <img src="@/assets/images/home/re-control-icon.svg"></img>
          <span>遥控器说明</span>
        </div>
        <div class="menu-item-2" @click="handleScanClick">
          <img src="@/assets/images/home/band-icon.svg"></img>
          <span>身份认证</span>
        </div>
      </div>
    </div>
  </div>
  <!-- 二次确认弹窗 -->
  <CustomDialog
    :showCancel="showCancel"
    ref="customDialogRef"
    :message="customDialogMessage"
  />
  <van-popup
    v-model:show="showScanner"
    position="bottom"
    :style="{ height: '100%', width: '100%' }"
    :overlay="true"
    :close-on-click-overlay="false"
  >
    <div class="scanner-popup">
      <!-- 扫码组件 -->
      <IconCommunity
        v-if="showScanner"
        @scan-success="handleScanSuccess"
        @scan-close="handleScanClose"
      />
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import { useAuthStore } from '../stores/auth'
import { getVideoAppointment, type NoticeInfo, lickRecordApi} from '@/services/home'
import IconCommunity from '@/components/barcodeScanner/IconCommunity.vue'; // 扫码
import { ref, onMounted, onUnmounted } from 'vue'
import { showNotify, showToast } from 'vant'
import { useRouter } from 'vue-router'
import appApi from '@/services/loginApi'
import { scanQRCode } from '@/utils/qr-code'
import { initWxSdk } from '@/utils/wxSdk'
import CustomDialog  from '@/components/common/customDialog.vue';
import { useH104Tab } from '@/stores/h104'
import { useH101FormStore } from '@/stores/h101'
import { useH102FormStore } from '@/stores/h102'
import { useH103FormStore } from '@/stores/h103'
import { useH105FormStore } from '@/stores/h105'
const router = useRouter()

// 菜单跳转-根据需求描述设计页面编号路径
const menuLink = (flag: string) => {
  switch (flag) {
    case '0': // 解锁更多空气体验-点击跳转至维护的链接页面，初期为部品销售宣传落地页，由客服接待
      break
    case 'H101': // 维修
      lickRecordApi('维修') // 记录
      useH101FormStore().clearFormData(); // 防止重新创建之后，一直后退到首页，此时缓存时有数据的
      router.push('/page-h101')
      break
    case 'H102':  // 移机
      lickRecordApi('移机')
      useH102FormStore().clearFormData();
      router.push('/page-H102')
      break
    case 'H103': // 清洗保养
      useH103FormStore().clearFormData();
      lickRecordApi('清洗保养')
      router.push('/page-H103')
      break
    case 'H104': // 进度查询
      if(!localStorage.getItem('userInfo')) {
        showToast('请先登录')
        return 0
      }
      useH104Tab().setSelectTab('1')
      router.push({
        path: '/page-h104'
      })
      break
    case 'H105': // 在线预约
      useH105FormStore().clearFormData();
      router.push('/page-H105')
      break
    case 'H106': // 视频预约
      router.push('/page-H106')
      break
    case 'H107': // 收费标准
      lickRecordApi('收费标准')
      router.push('/page-H107')
      break
    case 'H108': // 保修政策
      lickRecordApi('保修政策')
      router.push('/page-H108')
      break
    case 'H109': // 服务标准
      lickRecordApi('服务标准')
      router.push('/page-H109')
      break
    case 'H110': // 故障代码
      lickRecordApi('故障代码')
      router.push('/page-H110')
      break
    case 'H111': // 遥控器说明-外部连接
      window.location.href = 'https://wechat.daikin-china.com.cn/exhibition/wechat/instru_index'
      // router.push('/page-H111')
      break
    default:
  } 
}
const showScanner = ref(false);
const getScannedUrl = (value: string): string | null => {
  const normalizedValue = value.trim();

  try {
    const parsedUrl = new URL(normalizedValue);
    if (parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:') {
      parsedUrl.protocol = 'https:';
      return parsedUrl.toString();
    }
    return null;
  } catch {
    return null;
  }
};

const navigateToScannedResult = (value: string) => {
  const scannedUrl = getScannedUrl(value);
  if (!scannedUrl) {
    showToast({
      message: '扫码结果不是有效链接',
      duration: 3000,
      type: 'fail'
    });
    return;
  }

  window.location.href = scannedUrl;
};

// 检查扫码环境
const checkScanEnvironment = (): boolean => {
  // 开发环境允许 localhost，生产环境需要 HTTPS
  const isLocalhost = window.location.hostname.includes('localhost');
  const isHttps = window.location.protocol === 'https:';
  
  if (!isHttps && !isLocalhost) {
    showToast({
      message: '扫码功能需要在 HTTPS 环境下使用',
      duration: 3000,
      type: 'fail'
    });
    return false;
  }

  // 检查浏览器是否支持摄像头 API
  if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
    showToast({
      message: '当前浏览器不支持扫码功能',
      duration: 3000,
      type: 'fail'
    });
    return false;
  }

  return true;
};
const customDialogRef = ref();
const customDialogMessage = ref('')
const showCancel = ref(true);
const isWxReady = ref(false); 
// 点击扫码图标
const handleScanClick = async () => {
  showCancel.value = false
  customDialogMessage.value = '功能开发中，敬请期待'
  const dialogResult = await customDialogRef.value.open();
  setTimeout(() => {
    showCancel.value = true
  }, 300)
  // const appFromType = localStorage.getItem('appFromType');
  // if (appFromType === '1') { // 小程序环境
  //   if (!isWxReady.value) {
  //     try {
  //       isWxReady.value = await initWxSdk();
  //     } catch (err) {
  //       const error = err as Error;
  //       showToast({
  //         message: error.message || '微信扫码功能初始化失败',
  //         duration: 3000,
  //         type: 'fail'
  //       });
  //       return;
  //     }
  //   }
  //   if (!isWxReady.value || !window.wx?.scanQRCode) {
  //     showToast({
  //       message: '当前微信环境不支持扫码能力，请在微信内重试',
  //       duration: 3000,
  //       type: 'fail'
  //     });
  //     return;
  //   }
  //   customDialogMessage.value = '允许“大金服务”使用相机权限？'
  //   const dialogResult = await customDialogRef.value.open();
  //   if (dialogResult === '2') { // 确定
  //     try {
  //       const result = await scanQRCode()
  //       if (result) {
  //         navigateToScannedResult(result)
  //       }
  //     } catch (error) {
  //       console.error('微信扫码失败：', error)
  //       const errMsg = (error as Error)?.message || '扫码失败，请重试';
  //       showToast({
  //         message: errMsg,
  //         duration: 3000,
  //         type: 'fail'
  //       })
  //     }
  //   }
  //   return;
  // }
  // if (checkScanEnvironment()) {
  //   showScanner.value = true;
  // }
};

// 扫描成功回调
const handleScanSuccess = async(barcode: string) => {
  console.log('扫描到的条码111:', barcode);
  // 关闭扫描弹窗
  showScanner.value = false;
  if (barcode) {
    navigateToScannedResult(barcode)
  }
};

// 扫描关闭回调（从扫码组件内部触发）
const handleScanClose = () => {
  showScanner.value = false;
  showToast({
    message: '已关闭扫码',
    duration: 1000,
  });
};
const appointmentStatus = ref('0')
const appointmentSign = ref('')
// 获取视频预约
const getVideoAppointmentInfo = async () => {
  const hasLoggedWithParams = localStorage.getItem('hasLoggedWithParams') === 'true';
  if (hasLoggedWithParams) {
    const data = await getVideoAppointment() as NoticeInfo
    appointmentStatus.value = data.appointmentStatus || '0'
    appointmentSign.value = data.appointmentSign || ''
  }
}
const miniAppVideo = () => {
  if (!appointmentSign.value) {
    showToast('视频连接错误，请联系管理员')
    return 0
  }
  const appFromType = localStorage.getItem('appFromType');
  if (appFromType === '1') { // 小程序
    if (window.wx && window.wx.miniProgram) {
      let url = '/pages/videoApp/index?appointmentSign=' + appointmentSign.value
      window.wx.miniProgram.navigateTo({
        url: url
      })
    }
  } else {
    window.location.href = appointmentSign.value
  }
}
// 清理路由历史栈
const ensureSingleHistory = (): Promise<void> => {
  return new Promise((resolve) => {
    const currentUrl = window.location.href
    const currentState = history.state
    if (window.history.length > 2) {
      window.history.go(-(window.history.length - 1))
      setTimeout(() => {
        // 现在应该在第一条记录，替换它
        window.history.replaceState(currentState, '', currentUrl)
        console.log('清理完成, 长度:', window.history.length)
        resolve()
      }, 100)
    } else {
      window.history.replaceState(currentState, '', currentUrl)
      resolve()
    }
  })
}
onMounted(async () => {
  window.history.replaceState(history.state, '', window.location.href) // 使其栈清空
  console.log('清理完成, 长度:', window.history.length)
  // await ensureSingleHistory()
  try {
    if (typeof window === 'undefined') return;
    const urlParams = new URLSearchParams(window.location.search);
    const finalEncryptedParams = urlParams.get('finalEncryptedParams') || ''; // 小程序加密信息
    const sessionKeyFlag = urlParams.get('hasLoggedWithParams') || ''; // 小程序跳转的时候发现sessionKey过期了，重新登录的标识，值为true或者false，true代表已经重新登录过了
    if (sessionKeyFlag === '0') { // 失效
      localStorage.setItem('hasLoggedWithParams', 'false');
    }
    const hasLoggedWithParams = localStorage.getItem('hasLoggedWithParams') === 'true';
    const appFromType = urlParams.get('appFromType') || ''; // 应用程序来源-小程序：1, 金制app ''
    if (appFromType) {
      localStorage.setItem('appFromType', appFromType);
    }
    if (localStorage.getItem('appFromType') === '1') {
      // SDK 预热不阻塞后续登录与页面初始化流程
      void initWxSdk()
        .then(() => {
          isWxReady.value = true;
          console.log('微信 JS-SDK 授权成功');
        })
        .catch((err) => {
          isWxReady.value = false;
          const error = err as Error;
          console.warn('微信 JS-SDK 预初始化失败，等待用户触发扫码时再重试:', error.message);
        });
    }
    if (finalEncryptedParams) { // 小程序 只要有加密串 我就去解密获取最新的
      await appApi.handleLogin(finalEncryptedParams)
      getVideoAppointmentInfo()
    } else if (!finalEncryptedParams && !hasLoggedWithParams) { // 没登录
      // 清除缓存
      localStorage.removeItem('app_access_token');
      localStorage.removeItem('userInfo');
      localStorage.setItem('hasLoggedWithParams', 'false');
      const authStore = useAuthStore();
      authStore.clearUserInfo();
    } else { // 返回首页
      const authStore = useAuthStore();
      const storeUserInfo = authStore.getUserInfo();
      if (localStorage.getItem('userInfo') && !storeUserInfo) { // session 中有userInfo, 但是vuex中没有。则存储一下
        console.log('session 中有userInfo, 但是vuex中没有。则存储一下')
        try {
          let sessionUserInfo = JSON.parse(localStorage.getItem('userInfo') as string)
          authStore.setUserInfo(sessionUserInfo)
        } catch (error) {
          console.error('解析 userInfo 失败:', error);
        }
      }
      getVideoAppointmentInfo()
    }
  } catch (error) {
    const errorMsg = (error as Error).message;
    showNotify({
      type: 'danger',
      message: errorMsg,
      duration: 3000
    })
  }
})
onUnmounted(() => {
})
</script>

<style scoped lang="scss">
.home-container {
  width: 100%;
  padding: 0;
  margin: 0;
  height: 100%;
  position: relative;
  flex: 1;
}
.home-back-img {
  position: fixed; /* 脱离文档流，不影响父容器高度计算 */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0; /* 上下左右都贴紧父容器，拉伸填充父元素高度和宽度 */
  width: 100%; /* 宽度占满父容器 */
  height: 100%; /* 高度占满父容器（配合 top/bottom:0 实现拉伸） */
  object-fit: cover; /* 保持图片比例，裁剪多余部分（避免拉伸变形） */
  object-position: top center; /* 强制图片顶部居中对齐（关键！） */
  z-index: 1;
}
/* 顶部横幅 */
.banner {
  padding: 0px;
  width: 100%;
  box-sizing: border-box;
  height: auto;
  position: relative;
  z-index: 1;
  >img {
    width: 100%; /* 宽度占满父容器 */
    height: auto; /* 高度自适应，保持图片原始宽高比 */
    object-fit: cover; /* 若父容器宽度变化，图片裁剪适配（不拉伸） */
    display: block; /* 清除 img 默认的 inline 空隙（避免底部留白） */
  }
  .title-box {
    position: absolute;
    left: 1rem;
    top: 2rem;
    display: flex;
    flex-direction: column;
    .logo {
      margin-bottom: 1.6rem;
      width: 8.4rem;
    }
    >span{
      padding-left: 1.7rem;
    }
    .tip {
      color: white;
      font-size: 3rem;
      font-weight: bold;
      line-height: 3.6rem;
    }
    .link {
      color: white;
      font-size: 1rem;
      margin-top: 1.2rem;
      padding: .3rem .8rem;
      background: #0097E0;
      border-radius: 8px;
      display: inline;
      align-self: flex-start;
      margin-left: 1.7rem;
    }
  }
}
/* 快捷菜单 */
.banner-menu {
  z-index: 100;
  position: relative;
  background-color: #e5e5e5;
  padding: 1.4rem 0rem;
  width: calc(100% - 4rem);
  margin: auto;
  height: 11rem;
  border: 2px solid white;
  border-radius: 2rem;
  margin-top: -5.5rem;
  display: flex;
  justify-content: space-between;
  .menu-item{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    position: relative;
    width: 25%;
    &::after {
      content: '';
      position: absolute;
      right: 0;
      top: 20%;
      height: 60%;
      width: 1px;
      background-color: white;
    }
    &:nth-child(4n)::after {
      display: none;
    }
    .icon {
      width: 4.8rem;
      height: 4.8rem;
      background-color: white;
      border-radius: .8rem;
      border: 1px solid rgba(255,255,255,0.3);
      >img {
        width: 3.2rem;
        height: 3.2rem;
      }
    }
    >span {
      font-size: var(--font-size);
      color: var(--font-color);
    }
  }
}
.block-title {
  color: #242323;
  font-size: 1.6rem;
  line-height: 1.6rem;
  font-weight: 400;
}
.appointment-block{
  position: relative;
  z-index: 100;
  width: calc(100% - 4rem);
  margin: 2.4rem auto 3rem;
  .block-title {
    position: absolute;
    top: 0;
    left: 0;
  }
  .cnt {
    position: relative;
    .tip-box {
      position: absolute;
      top: 4.5rem;
      left: 1.5rem;
      .hi {
        font-weight: 500;
        font-size: 15px;
        color: #3A3A3A;
        line-height: 14px;
      }
      .ti {
        margin-top: 1.4rem;
        font-size: var(--font-size);
        color: var(--font-color);
      }
    }
    .btn {
      position: absolute;
      bottom: 0;
      left: 0;
      color: #3E8FD2;
      font-size: 1.4rem;
      width: 100%;
      height: 5rem;
      line-height: 5rem;
      text-align: center;
    }
  }
}
.self-service-block {
  .block-title {
    position: relative;
    margin-bottom: 1.6rem;
  }
  .cnt2 {
    width: 100%;
    min-height: 15rem;
    background: rgba(249,249,249,0.6);
    box-shadow: inset 0px 1px 3px 0px rgba(255,255,255,0.5);
    border-radius: 20px;
    border: 1px solid #FFFFFF;
    padding: 1.6rem 0rem;
    display: flex;
    flex-wrap: wrap;
    .menu-item-2 {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: 25%;
      margin-bottom: 2rem;
      height: 4.8rem;
      &:nth-child(n+5) {
        margin-bottom: 0rem;
      }
      >img {
        display: inline;
        width: 2.8rem;
        height: 2.8rem;
      }
      >span{
        font-size: var(--font-size);
        color: var(--font-color);
        text-align: center;
        line-height: 1.6rem;
      }
    }
  }
}
/* 响应式布局 */
@media (max-width: 750px) {
  .banner {
  }
  /* 语音提示栏 */
  .banner-menu {
  }
}
</style>
